import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDriverAuth } from '@/hooks/use-driver-auth';

interface ProtectedDriverRouteProps {
  children: React.ReactNode;
}

export function ProtectedDriverRoute({ children }: ProtectedDriverRouteProps) {
  const { isAuthenticated, isLoading } = useDriverAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate('/driver/auth', { replace: true });
    }
  }, [isAuthenticated, isLoading, navigate]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return null;
  }

  return <>{children}</>;
}
